/** @flow */
import MultiGrid from './MultiGrid';

export default MultiGrid;
export {MultiGrid};



// WEBPACK FOOTER //
// ./src/features/scorecard/MultiGrid/index.js